// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-f051e0a6] .el-dialog__body {\n  padding: 0 20px;\n}\n", ""]);
// Exports
module.exports = exports;
